export const endpoint = {
  loadSubscriberGroupOptions: 'subscriberGroup/search',
  deleteSubscriberGroup: 'subscriberGroup'
};
